import ReceiptPostUploadIcon from '@/assets/icons/capture_success.svg?react';
import Check from '@/assets/icons/check.svg?react';
import { Button } from '@/components/ui/button';
import { Link, useLocation } from 'wouter';
import Close from '@/assets/icons/closeUpload.svg?react';
import { CoinRain } from '@/components/upload-success/CoinRain';
import { useQuery } from '@tanstack/react-query';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { useAddReceiptContext } from '@/providers/AddReceiptContext';

export function UploadSuccess() {
  const { apiFetch, userRole } = useOpenApiClient();
  const [, setLocation] = useLocation();
  const { uploadReceiptMutation } = useAddReceiptContext();

  useQuery({
    queryKey: ['v1', 'receipts', uploadReceiptMutation?.data?.data?.data?.id],
    queryFn: () =>
      apiFetch.GET('/receipts/{receipt_id}', {
        params: {
          path: {
            receipt_id: uploadReceiptMutation?.data?.data?.data?.id || '',
          },
        },
      }),
    refetchInterval: 5 * 1000,
    select: (data) => {
      if (data.data?.data?.status !== 'processing') {
        setLocation(`/receipts/${uploadReceiptMutation?.data?.data?.data?.id}`);
      }
      return data.data?.data;
    },
    enabled: uploadReceiptMutation?.isSuccess,
  });
  return (
    <Sheet open={true} onOpenChange={() => setLocation('/receipts')}>
      <SheetContent hideClose side="top" className="pt-4 pb-7">
        <div className="-z-10 flex h-screen flex-col items-center px-2 py-2">
          <div className="z-10 flex h-full w-full flex-col items-center">
            <div className="mb-18 flex w-full justify-end">
              <Link href="/receipts" asChild>
                <Button variant="ghost" size="icon">
                  <Close />
                </Button>
              </Link>
            </div>
            <ReceiptPostUploadIcon />
            <p className="text-foreground mt-9 flex items-center gap-2 text-2xl font-bold">
              <Check />
              {uploadReceiptMutation.isPending && 'Receipt submitted!'}
              {uploadReceiptMutation.isSuccess && 'Receipt captured!'}
            </p>
            <p className="text-foreground px-8 pt-2 text-center text-base">
              {uploadReceiptMutation.isPending &&
                "Your receipt is on the wire! We're receiving it, one pixel at a time."}
              {uploadReceiptMutation.isSuccess &&
                userRole === 'live' &&
                "The Enrich Network team thanks you for participating in our Snap & Earn program. You have earned 100 points. Once you collect 1000 points, you'll receive a gift card via email."}
              {uploadReceiptMutation.isSuccess &&
                userRole === 'demo' &&
                'Checking for enriching opportunities, one cent at a time. This might take a while.'}
            </p>
            {uploadReceiptMutation.isSuccess && (
              <Link href={`/receipts/${uploadReceiptMutation?.data?.data?.data?.id}`} replace>
                <Button variant="ghost" className="text-primary">
                  View Receipt
                </Button>
              </Link>
            )}
          </div>
          <CoinRain className="z-0" />
        </div>
      </SheetContent>
    </Sheet>
  );
}
